export default function({ $gtm, $config, app }) {
  let id = $config.gtm.id
  if (app.i18n.locale === "es") {
    id = $config.gtm.id_es
  }
  $gtm.init(id)
}
